"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlButtonDeck", function () {
  return {
    restrict: "E",
    transclude: true,
    replace: true,
    template: "<div class=\"tl-button-deck\" ng-transclude></div>"
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/buttons/tl-button-deck.js
// module id = 2920
// module chunks = 13